import { render, staticRenderFns } from "./TheFeedbackModalComments.vue?vue&type=template&id=4d7271be&"
import script from "./TheFeedbackModalComments.vue?vue&type=script&lang=js&"
export * from "./TheFeedbackModalComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports